
import { useSettingModal } from '../../../../hooks/Context';
import {SettingContextI} from '../../../../types';
import { Button } from '../SettingButton';
import React from 'react';
import CreateInduction from './CreateInduction';

  
const CreateBtn: React.FC<any> = (props) => {
    const { setModalContent, setShowModal }: SettingContextI = useSettingModal();

    const onClick = () => {
        setModalContent(<CreateInduction/>);
        setShowModal(true);
    };
    
    return (
        <Button onClick={onClick} 
            style={{backgroundColor: "#11643C", cursor: "pointer",
            color: "#fff", border: "none", outline: "none", padding: "15px 20px", borderRadius: "5px"}}
        >
            Create Induction
        </Button>
    )
};

export default CreateBtn;

